import NativeAuthCallbackPage from '@/pages/native/auth-callback/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/native/auth-callback')({
  component: NativeAuthCallbackPage,
})
